import { IonApp, IonRouterOutlet, IonSplitPane, setupIonicReact } from '@ionic/react';
import { IonReactRouter } from '@ionic/react-router';
import { Redirect, Route } from 'react-router-dom';
import Menu from './components/Menu';
import Autores from './pages/Autores';
import Abrev from './pages/Abrev';
import Calculo from './pages/Calculo';
import Farmacos from './pages/Farmacos';

/* Core CSS required for Ionic components to work properly */
import '@ionic/react/css/core.css';

/* Basic CSS for apps built with Ionic */
import '@ionic/react/css/normalize.css';
import '@ionic/react/css/structure.css';
import '@ionic/react/css/typography.css';

/* Optional CSS utils that can be commented out */
import '@ionic/react/css/padding.css';
import '@ionic/react/css/float-elements.css';
import '@ionic/react/css/text-alignment.css';
import '@ionic/react/css/text-transformation.css';
import '@ionic/react/css/flex-utils.css';
import '@ionic/react/css/display.css';

/* Theme variables */
import './theme/variables.css';

setupIonicReact();

const App: React.FC = () => {
  return (
    <IonApp>
      <IonReactRouter>
        <IonSplitPane contentId="main">
          <Menu />
          <IonRouterOutlet id="main">
            <Route path={`${process.env.PUBLIC_URL}/`} exact={true}>
              <Redirect to={`${process.env.PUBLIC_URL}/arbol`} />
            </Route>
            <Route path={`${process.env.PUBLIC_URL}/arbol`} exact={true}>
              <Calculo />
            </Route>
            <Route path={`${process.env.PUBLIC_URL}/autores`} exact={true}>
              <Autores />
            </Route>
            <Route path={`${process.env.PUBLIC_URL}/farmacos`} exact={true}>
              <Farmacos/>
            </Route>
            <Route path={`${process.env.PUBLIC_URL}/abrev`} exact={true}>
              <Abrev/>
            </Route>
          </IonRouterOutlet>
        </IonSplitPane>
      </IonReactRouter>
    </IonApp>
  );
};

export default App;
